import { BsPersonVcard } from "react-icons/bs";
import { FaRegCheckSquare } from "react-icons/fa";
import { FaPeopleGroup } from "react-icons/fa6";
import { RiFileDownloadLine } from "react-icons/ri";

export default function Welcome() {
  return (
    <>
      <p className="mb-2 font-bold">Take the hassle out of attendance.</p>
      <p>
        Streamline your classroom or group attendance with RollCall2. This
        intuitive app allows educators and administrators to efficiently manage
        student attendance, track participation, and generate detailed reports.
      </p>
      <p className="my-2 font-bold">Key Features:</p>
      <ul className="list-inside list-none">
        <li className="ms-2 mb-2">
          <BsPersonVcard className="me-2 inline text-2xl" />
          Manage Student Info: Easily store and organize student profiles with
          essential details.
        </li>
        <li className="ms-2 mb-2">
          <FaPeopleGroup className="me-2 inline text-2xl" /> Assign Students to
          Classes: Add and remove students from classes or groups with just a
          few taps.
        </li>
        <li className="ms-2 mb-2">
          <FaRegCheckSquare className="me-2 inline text-2xl" /> Mark Attendance:
          Quickly mark attendance for each session, including options for
          start/end times and optional notes
        </li>
        <li className="ms-2 mb-2">
          <RiFileDownloadLine className="me-2 inline text-2xl" /> Attendance
          Reports: Export attendance data as a downloadable spreadsheet for easy
          tracking and analysis.
        </li>
      </ul>
      <p className="my-2">
        RollCall2 saves you time and keeps your records organized, so you can
        focus on teaching, not paperwork.
      </p>
      <p className="mt-4 font-bold">
        RollCall2 is free to try for the first five attendance events.
      </p>
      <ul className="list-inside list-disc">
        <li>Subscribe monthly or annually.</li>
        <li>All platforms included.</li>
      </ul>
    </>
  );
}
